import { render, staticRenderFns } from "./MyNoticeBoardPosts.vue?vue&type=template&id=5f8e5ec3&"
import script from "./MyNoticeBoardPosts.vue?vue&type=script&lang=js&"
export * from "./MyNoticeBoardPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports